<template>
  <div></div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  data() {
    return {
      meLoading: false,
      storeLoading: false,
    }
  },
  computed: {
    ...mapState('auth', ['info', 'me']),
    ...mapGetters('auth', ['isServiceSetUse']),
  },
  watch: {
    info(v) {
      if (v == null) {
        return
      }
      this.getMe()
    },
    me(v) {
      if (!!v) {
        this.modifyStore()
      }
    },
  },
  async created() {
    await this.syncMe()
  },
  methods: {
    ...mapActions('auth', ['getMe', 'updateMe', 'updateServiceUse', 'syncMe']),
    ...mapActions('store', ['updateStore']),
    async updateCoupon() {
      const couponText = this.$cookies.get('coupon')
      if (!!couponText) {
        await this.updateMe({ couponText })
        this.$cookies.remove('coupon')
      }
    },
    async modifyStore() {
      if (this.storeLoading) {
        return
      }

      const { store } = this.me
      const regNum = store.businessLicenseNumber || null
      const storeName = store.name || null

      this.storeLoading = true
      if (!regNum || !storeName) {
        const businessLicenseNumber = this.$cookies.get('businessLicenseNumber')
        const companyName = this.$cookies.get('companyName')

        if (!!businessLicenseNumber && !!companyName) {
          await this.updateStore({ businessLicenseNumber, name: companyName })
        }
      }
    },
  },
}
</script>
